import { Link } from "react-router-dom";

import style from "./style.module.scss";
import { Button } from "../../../ui";
import { useScrollReveal } from "../../../hooks/use-scroll-reveal";

interface CtaSectionProps {
  label: string;
  to: string;
}

function CtaSection({ label, to }: CtaSectionProps) {
  const ref = useScrollReveal<HTMLDivElement>({ direction: "scale", delay: 100 });

  return (
    <section className={style.finalCta}>
      <div className={style.finalCtaGlow} />
      <div ref={ref} className={style.finalCtaContent}>
        <p className={style.finalCtaText}>Vos souvenirs n'attendent que vous</p>
        <Link to={to} className={style.finalCtaLink}>
          <Button className={style.finalCtaButton} isPrimary isLarge>
            {label}
          </Button>
        </Link>
      </div>
    </section>
  );
}

export default CtaSection;
